import { Injectable } from '@angular/core';
import {SweetalertService} from "../../shared/sweetalert/sweetalert.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private alertService: SweetalertService,
              private router: Router) {
  }

  handle(request: any, error: any): void {
    if (error.url === 'https://graph.microsoft.com/v1.0/me/photo/$value'
        || error.url === 'https://graph.microsoft.com/v1.0/me'){
    }else if (error.url.includes('/web/attendance/event/')) {
      if(error?.error?.data == 'Attendance Already Completed. Thank You'){
        this.alertService.autoClose(error?.error?.data, 'Success', 'success');
      }else {
        this.alertService.autoClose(error?.error?.data, error?.error?.message,'error');
      }
    }else {
      if (error.status === 403 || error.status === 401) {
        this.handle_401();
      } else if (error.status === 404) {
          this.handleDefault(error);
      } else if (error.status == 400 && error.error.message == 'Validation failed') {
        this.handleValidationError(error);
      } else{
          this.handleDefault(error);
      }
    }
  }

  private handleValidationError(error: any): void {
    this.alertService.errorInValidationInfo(error.error, "Something went wrong !");
  }

  private handleDefault(error: any): void {
    this.alertService.errorInInfo(error?.error?.data, error?.error?.message);
  }

  private handle_401(){
    this.alertService.loginError("Unauthorized","Please contact administrator.")
    this.router.navigate(['/signin'])
  }

  private handle_404(){
    this.alertService.loginError("Unauthorized","Please login again.")
    this.router.navigate(['/signin'])
  }
}
